<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="resourceName" label="资源名称"></el-table-column>
            <el-table-column prop="groupName" label="组名称"></el-table-column>

            <el-table-column align="center" label="组类型">
                <template slot-scope="scope">
                    <span>{{scope.row.groupType == 1 ? '指定用户' : (scope.row.groupType == 2 ? '全员' : '指定部门')}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column prop="userCount" label="用户数"></el-table-column>-->
            <el-table-column label="操作" fixed="right" width="480">
                <template slot-scope="scope">
                    <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="warning " size="mini" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button v-if="scope.row.groupType == 1" type="success " size="mini" @click="handleUsers(scope.row)">用户</el-button>
                    <el-button type="success " size="mini" @click="handleGroups(scope.row)">能看到的组</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="资源/菜单数据权限用户组" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="名称" :required="true">
                    <el-input v-model="form.groupName" placeholder="组名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="组类型">
                    <el-select v-model="form.groupType" clearable  placeholder="组类型">
                        <el-option label="指定用户" value=1></el-option>
                        <el-option label="全员" value=2></el-option>
                        <el-option label="指定部门" value=3></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog  title="组内用户" :visible.sync="dialogFormVisibleleaf" center :fullscreen="true">
            <div>
                <template>
                    <el-transfer
                            filterable
                            :filter-method="filterMethod"
                            filter-placeholder="请输入邮箱"
                            v-model="chosedUsers"
                            :data="allUsers"
                            :titles="['全部用户', '组内用户']"
                            :props="{
                            key: 'USER_ID',
                            label: 'USER_NAME'
                        }">
                    </el-transfer>
                </template>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleleaf = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddLeaf">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog  title="可看到的组" :visible.sync="dialogFormVisibleleafGroup" center :fullscreen="true">
            <div>
                <template>
                    <el-transfer
                            filterable
                            :filter-method="filterMethodGroup"
                            filter-placeholder="请输入组名"
                            v-model="chosedGroups"
                            :data="allGroups"
                            :titles="['全部组', '有权看到的组']"
                            :props="{
                                key: 'groupId',
                                label: 'groupName'
                        }">
                    </el-transfer>
                </template>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleleafGroup = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddGroup">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getResourceGroups,
        getResourceGroupUsers,
        saveResourceGroups,
        saveResourceGroupUsers,
        delResourceGroup,
        getCooperativeAllUserList,
        getAllResourceGroups,
        getResourceVisibleGroups,
        saveResourceGroupRelation
    } from '../../api/api'

    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                dataLeafList: [],
                loading: true,
                dialogFormVisible: false,
                dialogFormVisibleleaf:false,
                dialogFormVisibleleafGroup:false,
                resourceId:this.$route.query.resourceId,
                groupId:'',
                userIds : [],
                formInline: {
                    resourceId: '',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    groupId: '',
                    groupName: '',
                    groupType: '',
                    resourceId: ''
                },
                allUsers: [],
                allGroups: [],
                chosedUsers: [],
                chosedGroups: []
            }
        },
        //挂载时候执行
        mounted() {
            this.groupId = '';
            this.getList();
        },
        methods: {
            getList() {
                this.loading = true;
                this.formInline.resourceId = this.resourceId;
                getResourceGroups(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.form= {
                    groupId: '',
                    groupName: '',
                    resourceId: this.resourceId
                }
                this.dialogFormVisible = true;
            },
            handleUpdate(row) {
                this.form= {
                    groupId: row.groupId,
                    groupName: row.groupName,
                    groupType: row.groupType,
                    resourceId: this.resourceId
                }
                this.dialogFormVisible = true;
            },
            handleDelete(row) {
                delResourceGroup({"groupId":row.groupId}).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveResourceGroups(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            handleUsers(row) {
                this.groupId = row.groupId;
                this.userIds = [];
                this.dialogFormVisibleleaf = true;
                this.allUsers = [];
                this.chosedUsers = [];
                this.getLeafList();
            },
            handleGroups(row) {
                this.groupId = row.groupId;
                this.dialogFormVisibleleafGroup = true;
                this.allGroups = [];
                this.chosedGroups = [];
                this.getGroupList();
            },

            getLeafList() {
                //未选用户列表
                getCooperativeAllUserList().then((res) => {
                    if(res.data.status == 200){
                        this.allUsers = res.data.value;
                        //已选用户列表
                        getResourceGroupUsers({"groupId":this.groupId}).then((res1) => {
                            if (res1.data.status == 200) {
                                console.log("=====",this.allUsers);
                                console.log("=====",res1.data.value);
                                for(var i = 0 ; i < res1.data.value.length; i++){
                                    this.chosedUsers.push(res1.data.value[i].userId);
                                }
                                // for(var i = 0 ; i < res1.data.value.length; i++){
                                //     for(var j = 0; j < this.allUsers.length; j++){
                                //         if(this.allUsers[j].USER_ID == res1.data.value[i].userId){
                                //             this.chosedUsers.push(this.allUsers[j].USER_ID);
                                //             break;
                                //         }
                                //     }
                                // }
                                console.log("=====",this.allUsers);
                                console.log("=====",this.chosedUsers);
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res1.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getGroupList() {
                //未选组列表
                getAllResourceGroups({'resourceId':this.resourceId}).then((res) => {
                    if(res.data.status == 200){
                        this.allGroups = res.data.value;
                        //已选用户列表
                        getResourceVisibleGroups({"resourceId":this.resourceId,"groupId":this.groupId}).then((res1) => {
                            if (res1.data.status == 200) {
                                for(var i = 0 ; i < res1.data.value.length; i++){
                                    this.chosedGroups.push(res1.data.value[i].visibleGroupId);
                                }
                                console.log("=====",this.allGroups);
                                console.log("=====",this.chosedGroups);
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res1.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            updateOrAddLeaf() {
                var userIdStr = "";
                for(var i = 0; i < this.chosedUsers.length; i++){
                    userIdStr = userIdStr + this.chosedUsers[i] + ",";
                }
                saveResourceGroupUsers({"groupId":this.groupId,"userIds":userIdStr}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            updateOrAddGroup() {
                var groupIdStr = "";
                for(var i = 0; i < this.chosedGroups.length; i++){
                    groupIdStr = groupIdStr + this.chosedGroups[i] + ",";
                }
                saveResourceGroupRelation({"groupId":this.groupId,"relations":groupIdStr}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            filterMethod(query, item) {
                return item.USER_NAME.indexOf(query) > -1;
            },
            filterMethodGroup(query, item) {
                return item.groupName.indexOf(query) > -1;
            }
        }
    }
</script>
<style>
    .el-transfer{
        margin-left: 20%;
        height: 600px;
    }
    .el-transfer-panel{
        width:30%;
        height: 600px;
    }
    .el-transfer-panel__list.is-filterable{
        height: 584px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sys/resourcegroup.vue